export default "__VITE_ASSET__DlVL5sWB__"